import { Box, Spacer, TextNew } from '@jfs/ui-new'
import { FC } from 'react'
import { transactionDetailsStrings } from '../../data/static/strings'
import { useWindowDimensions } from '../../util/util'
import { styles } from './styles'

export interface DetailsObj {
  timestamp: string
  ern: string
  failureReason: string
  channel: string
  amount: string
  rrn: string
  status: string
  currency: string
  originalTransactionId?: string
}

interface DetailsProps {
  details: DetailsObj
  path: string
}

const Details: FC<DetailsProps> = ({ details }: DetailsProps) => {
  const viewPortWidth = useWindowDimensions()
  const themes = styles(viewPortWidth)

  const getSubTitleId = () => {
    return details?.rrn ?? 'NA'
  }

  const TextLayout = ({ title, subTitle }: { title: string; subTitle: string }) => {
    return (
      <Box flexDirection={'row'}>
        <Box {...themes.detailsSubContainer}>
          <TextNew type={'body12'} fontWeight="bold">
            {title}
          </TextNew>
        </Box>
        <Box {...themes.detailsSubContainer} testID={`txn-${title?.replaceAll(' ', '')}`}>
          <TextNew type={'body12'} fontWeight="MEDIUM">
            {subTitle}
          </TextNew>
        </Box>
      </Box>
    )
  }
  const failureReason = details?.failureReason
  return (
    <Box {...themes.detailsContainer}>
      <TextNew type={'titleBold16'}>{transactionDetailsStrings.labelTransactionDetails}</TextNew>
      <Spacer size={16} />
      <Box {...themes.detailsMainContainer}>
        <Box {...themes.detailsContent} flexDirection={'column'}>
          <TextLayout title={transactionDetailsStrings.labelTimestamp} subTitle={details?.timestamp} />
          <Spacer size={8} />
          <TextLayout title={transactionDetailsStrings.labelERN} subTitle={details?.ern} />
          <Spacer size={8} />
          <TextLayout
            title={transactionDetailsStrings.labelFailureReason}
            subTitle={failureReason !== '' ? failureReason : 'NA'}
          />
          <Spacer size={8} />
          <TextLayout title={transactionDetailsStrings.labelChannel} subTitle={details?.channel} />
        </Box>
        <Box {...themes.divider} />
        <Box {...themes.detailsSideContainer}>
          <Box {...themes.detailsSubContainer} flexDirection={'column'}>
            <TextLayout
              title={transactionDetailsStrings.labelAmount}
              subTitle={details?.amount !== 'undefined' ? `${'\u20B9'}${'\u0020'} ${details?.amount}` : 'NA'}
            />
            <Spacer size={8} />
            <TextLayout title={transactionDetailsStrings.labelRRN} subTitle={getSubTitleId()} />
            <Spacer size={8} />
            <TextLayout title={transactionDetailsStrings.labelStatus} subTitle={details?.status} />
            <Spacer size={8} />
            <TextLayout title={transactionDetailsStrings.labelCurrency} subTitle={transactionDetailsStrings?.inr} />
            <TextLayout title={transactionDetailsStrings.terminalId} subTitle={details?.terminalId} />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default Details
